// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const SalesLeadActivityPriorityValues = ["LOW", "NORMAL", "HIGH"] as const;

export type SalesLeadActivityPriority = (typeof SalesLeadActivityPriorityValues)[number];

export const getSalesLeadActivityPriorityLabels = () => ({
	LOW: t("low"),
	NORMAL: t("normal"),
	HIGH: t("high"),
});

export const getSalesLeadActivityPriorityLabel = (value: SalesLeadActivityPriority): string => {
	return getSalesLeadActivityPriorityLabels()[value];
};
